import { authConfig } from '@/features/auth/config'

const endpoint = `${(authConfig.apiBaseUrl || authConfig.mainSiteUrl).replace(/\/+$/, '')}/api/subsite/music-gen/aliyun`

function createFileName() {
  return `ai-music-fun-music-${new Date().toISOString().replace(/[:.]/g, '-')}.mp3`
}

async function readDuration(blob: Blob): Promise<number> {
  const url = URL.createObjectURL(blob)
  try {
    return await new Promise((resolve) => {
      const audio = new Audio(url)
      audio.onloadedmetadata = () => resolve(Number.isFinite(audio.duration) ? audio.duration : 0)
      audio.onerror = () => resolve(0)
    })
  } finally {
    URL.revokeObjectURL(url)
  }
}

export const aliyunMusicService = {
  async generateMusicFile({
    prompt,
    gender,
    isInstrumental,
    onProgress,
  }: {
    prompt: string
    gender?: 'male' | 'female'
    isInstrumental?: boolean
    onProgress?: (stage: string) => void
  }) {
    onProgress?.('正在生成云端音乐...')
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt, gender, isInstrumental, format: 'mp3' }),
    })
    if (!response.ok) {
      const payload = (await response.json().catch(() => null)) as { message?: string } | null
      throw new Error(payload?.message || '云端音乐生成请求失败。')
    }
    onProgress?.('正在接收云端音乐...')
    const blob = await response.blob()
    if (!blob.size) throw new Error('云端音乐没有返回音频数据。')
    const file = new File([blob], createFileName(), { type: blob.type || 'audio/mpeg' })
    return { blob, file, duration: await readDuration(blob) }
  },
}
